export default "__VITE_ASSET__D2S8_q1y__"